import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IHistoryRecord, IObjectNameIdentifier } from "../../../../documaker/domain/format/objects";

export interface IInformationKeyHistoriesPropertyEditable {
  informationKeyHistories(): IPropertyEditable<IHistoryRecord<IObjectNameIdentifier>[]>;
}

export function instanceOfIInformationKeyHistoriesPropertyEditable(instance: any): instance is IInformationKeyHistoriesPropertyEditable {
  return instance
      && instance.informationKeyHistories
      && instanceOfIPropertyEditable<IHistoryRecord<IObjectNameIdentifier>[]>(instance.name());
}
